export const ActionTypes = {
  REQUEST: "ADMIN_FETCH_HABIT_AREAS_REQUEST",
  SUCCESS: "ADMIN_FETCH_HABIT_AREAS_SUCCESS",
  FAILURE: "ADMIN_FETCH_HABIT_AREAS_FAILURE",

  SUCCESS_SINGLE: "ADMIN_FETCH_HABIT_AREA_SUCCESS",
  UPDATE_SUCCESS: "ADMIN_UPDATE_HABIT_AREA_SUCCESS",
  CREATE_SUCCESS: "ADMIN_CREATE_HABIT_AREA_SUCCESS",
  DELETE_SUCCESS: "ADMIN_DELETE_HABIT_AREA_SUCCESS",
}

export interface IArea {
  id: number;
  name: string;
  description: string;
  code: string;
  default_order: number;
  area_icon: string;
  color_code_1: string;
  color_code_2: string | null;
  user_type: number;
}

interface NormalizedEntities {
  [key: string]: IArea;
}

export interface IState {
  entities: NormalizedEntities;
  ids: string[];
  count: number;
  loading: boolean;
  error: any;
}
